import React from 'react'
import GeneralInformation from './GeneralInformation'
import NctsErrors from './NctsErrors'

function DeclarationSummaryTab({ consignmentId } : { consignmentId: number | null }) {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <GeneralInformation consignmentId={consignmentId} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <NctsErrors />
        </div>
      </div>
    </div>
  )
}

export default DeclarationSummaryTab
